import React from 'react';
import Admin from './admin';
import AdminOverview from './overview';

const AdminLanding = () => {
  return (
    <>
      {' '}
      <Admin />
      <AdminOverview />
    </>
  );
};

export default AdminLanding;
